import { render, staticRenderFns } from "./showMails.vue?vue&type=template&id=0b9244a2"
import script from "./showMails.vue?vue&type=script&lang=js"
export * from "./showMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports